<div [ngClass]="theme$ | async">
  <div class="mat-typography mat-app-background">
    <app-nav></app-nav>
    @if (this.showToolbar) {
      <app-toolbar></app-toolbar>
    }
    <router-outlet></router-outlet>
    <footer></footer>
  </div>
</div>
